import React, { createContext, useContext, useEffect, useReducer } from 'react';

import { UserInfo } from '@/types/account';
import { Address } from '@/types/address';

import {
  resetAccountInfo,
  setTimeBannerCoupon,
  syncAccountInfo,
  syncAddressBook,
  syncFavoriteIds,
  syncLoginState,
  setDiscountCopy,
  syncCommonBarCopy,
  syncRewardsInfo,
  setShowFavoriteTip,
  syncUserPreOrderLogin,
  syncFavoriteClick,
  syncUserBoughtData,
  syncPdpSoldoutTip
} from './actions';
import reducers, { initState, IExtraAccountAttrs } from './reducers';

const MyContext = createContext<UserInfo & IExtraAccountAttrs & { dispatch?: React.Dispatch<any> }>(initState);

type Props = {
  children: React.ReactNode;
};

export const AccountProvider = ({ children }: Props) => {
  const [dataState, dispatch] = useReducer(reducers, initState);
  return <MyContext.Provider value={{ ...dataState, dispatch }}>{children}</MyContext.Provider>;
};

export default function useAccount() {
  const { dispatch, ...store } = useContext(MyContext);
  return {
    ...store,
    syncAccountInfo: (info: UserInfo) => {
      dispatch(syncAccountInfo(info));
    },
    syncFavoriteIds: (payload: number[]) => {
      dispatch(syncFavoriteIds(payload));
    },
    syncLoginState: (state: boolean) => {
      dispatch(syncLoginState(state));
    },
    resetAccountInfo: () => {
      dispatch(resetAccountInfo());
    },
    handleSyncAddressBook: (payload: Address[]) => {
      dispatch(syncAddressBook(payload));
    },
    handleUpdateTimeBannerCoupon: (payload: number) => {
      dispatch(setTimeBannerCoupon(payload));
    },
    setDiscountCopy: (payload: any) => {
      dispatch(setDiscountCopy(payload));
    },
    syncCommonBarCopy: (payload: any) => {
      dispatch(syncCommonBarCopy(payload || {}));
    },
    syncRewardsInfo: (payload: any) => {
      dispatch(syncRewardsInfo(payload));
    },
    showFavoriteTip: (payload: any) => {
      dispatch(setShowFavoriteTip(payload));
    },
    syncUserPreLogin: (payload: boolean) => {
      dispatch(syncUserPreOrderLogin(payload));
    },
    syncFavoriteClick: (payload: boolean) => {
      dispatch(syncFavoriteClick(payload));
    },
    syncUserBoughtData: (payload: any[]) => {
      dispatch(syncUserBoughtData(payload));
    },
    syncPdpSoldoutTip: (payload: boolean) => {
      dispatch(syncPdpSoldoutTip(payload));
    }
  };
}
